<template>
    <div>
        <div >
            <v-flex xs12>
                <v-btn block
                       v-if="intendedImageType!=='IMEI'"
                       color="secondary"
                       @click="deliverClickToFileInput"
                >
                    <v-flex xs10>
                        Gegenstand fotografieren
                    </v-flex>
                    <v-flex xs2>
                        <v-icon right>photo_camera</v-icon>
                    </v-flex>

                </v-btn
                >
                <v-textarea
                        v-if="intendedImageType==='IMEI'"
                        v-model="imei"
                        :loading="uploadRunning"
                        auto-grow
                        box
                        color="secondary"
                        label="Wie lautet die IMEI des Gegenstands?"
                        :hint="'Bitte ' + contextualImeiLabel + ' eintippen oder fotografieren. Die IMEI ist eine 15-stellige Nummer, die das Telefon eindeutig identifiziert. Zu finden ist sie meistens unter „Einstellungen – Über das Telefon“ oder mit der Suchfunktion in den Einstellungen. Bei Dual-SIM-Geräten reicht die erste IMEI.'"
                        persistent-hint
                        rows="1"
                        append-icon="photo_camera"
                        @click:append="deliverClickToFileInputImei"
                ></v-textarea>
            </v-flex>
            <v-flex xs12
                    v-if="intendedImageType !== 'IMEI'">
                <input id="productPhotoButtonMobile"
                       ref="productPhotoButtonMobile"
                       class="inputfile"
                       type="file"
                       capture="camera"
                       accept="image/*"
                       name="productPhotoButtonMobile"
                       @change="handleProductFiles()"
                >
            </v-flex>
            <v-flex xs12
                    v-if="intendedImageType==='IMEI'"
            >
                <input id="imeiPhotoButtonMobile"
                       ref="imeiPhotoButtonMobile"
                       class="inputfile"
                       type="file"
                       capture="camera"
                       accept="image/*"
                       name="imeiPhotoButtonMobile"
                       @change="handleImeiFiles()"
                >
            </v-flex>
        </div>
        <!-- ******** TEST Foto-Auswahl vom Endgerät ******** -->
        <div >
            <v-flex xs12>
                <v-btn block
                       v-if="intendedImageType!=='IMEI'"
                       color="secondary"
                       @click="deliverClickToFileUploadMobile"
                >
                    <v-flex xs10>
                        Datei hinzufügen
                    </v-flex>
                    <v-flex xs2>
                        <v-icon right>folder_open</v-icon>
                    </v-flex>

                </v-btn
                >
            </v-flex>
            <v-flex xs12
                    v-if="intendedImageType !== 'IMEI'">
                <input id="productFileUploadMobile"
                       ref="productFileUploadMobile"
                       class="inputfile"
                       type="file"
                       accept="image/*,.pdf"
                       name="productFileUploadMobile"
                       @change="handleAppendedFiles()"
                >
            </v-flex>
        </div>
        <!-- ******** ENDE TEST ********* -->
    </div>

</template>

<script>
    export default {
        name: "MakePhotoButtonMobile",
        data: () => {
            return {
                reader: new FileReader()
            }
        },
        computed: {
            contextualImeiLabel(){
                if(this.$store.state.work.forxchange.offerRequest.contract.products[
                    this.contractProductIndex
                    ].index == 2){
                    return "IMEI/Seriennummer";
                }
                return "IMEI";
            },
            uploadRunning() {
                return (this.reader.readyState == 1);
            },
            description: {
                get() {
                    return this.$store.state.work.forxchange.offerRequest.contract.products[
                        this.contractProductIndex
                        ].description;
                },
                set(value) {
                    this.$store.dispatch("work/setProductDescription", {
                        index: this.contractProductIndex,
                        text: value
                    });
                }
            },
            imei: {
                get() {
                    return this.$store.state.work.forxchange.offerRequest.contract.products[
                        this.contractProductIndex
                        ].imei;
                },
                set(value) {
                    this.$store.dispatch("work/setProductImei", {
                        index: this.contractProductIndex,
                        text: value
                    });
                }
            }
        },
        props: {
            icon: {
                type: String,
                default: "photo_camera"
            },
            buttonlabel: {
                type: String,
                default: "Jetzt fotografieren"
            },
            contractProductIndex: {
                default: 0,
                required: true
            },
            intendedImageType: {
                type: String,
                default: "Produkt"
            }
        },
        methods: {
            deliverClickToFileInput(){
                this.$refs.productPhotoButtonMobile.click();
            },
            deliverClickToFileInputImei(){
                this.$refs.imeiPhotoButtonMobile.click();
            },
            deliverClickToFileUploadMobile(){
                this.$refs.productFileUploadMobile.click();
            },
            handleProductFiles(){
                // console.log("In handleProductFiles ist contractProductIndex = ");
                // console.dir(this.contractProductIndex);
                if (this.$refs.productPhotoButtonMobile.files) {
                    var file = this.$refs.productPhotoButtonMobile.files[0];
                    let fileTypes = ['jpg', 'jpeg', 'png'];
                    let self = this;
                    self.reader.onload = function(e) {
                        // console.log("In reader.onload ist contractProductIndex = ");
                        // console.dir(self.contractProductIndex);
                        self.$store.dispatch('work/storeProductPhoto',{ contractProductIndex: self.contractProductIndex, imageData: e.target.result, imageType: extension, fileName: file.name});
                    };
                    if(file){
                        self.reader.readAsDataURL(file);
                        var extension = file.name.split('.').pop().toLowerCase();
                    }
                }
            },
            handleImeiFiles(){
                if (this.$refs.imeiPhotoButtonMobile.files) {
                    var file = this.$refs.imeiPhotoButtonMobile.files[0];
                    let fileTypes = ['jpg', 'jpeg', 'png'];
                    let self = this;
                    self.reader.onload = function(e) {
                        self.$store.dispatch('work/storeImeiPhoto',{ contractProductIndex: self.contractProductIndex, imageData: e.target.result, imageType: extension, fileName: file.name});
                    };
                    if(file){
                        self.reader.readAsDataURL(file);
                        var extension = file.name.split('.').pop().toLowerCase();
                    }
                }
            },
            handleAppendedFiles(){
                if (this.$refs.productFileUploadMobile.files) {
                    var file = this.$refs.productFileUploadMobile.files[0];
                    let fileTypes = ['jpg', 'jpeg', 'png'];
                    let self = this;
                    if(file){
                        self.reader.readAsDataURL(file);
                        var extension = file.name.split('.').pop().toLowerCase();
                    }
                    self.reader.onload = function(e) {
                        if(fileTypes.indexOf(extension) > -1){
                            self.$store.dispatch('work/storeProductPhoto',{ contractProductIndex: self.contractProductIndex, imageData: e.target.result, imageType: extension, fileName: file.name});
                        }
                        if(extension === 'pdf'){
                            self.$store.dispatch('work/storeProductPdf',{ contractProductIndex: self.contractProductIndex, fileData: e.target.result, fileType: 'pdf', fileName: file.name});
                        }
                    };
                }
            }
        },
        mounted(){
            // console.log("In mounted ist contractProductIndex = ");
            // console.dir(this.contractProductIndex);
            },
        updated() {
            // console.log("In updated ist contractProductIndex = ");
            // console.dir(this.contractProductIndex);
        }
    }
</script>

<style scoped>
    .inputfile {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
    input#productFotoButtonMobile{
        opacity: 0.1;
    }

</style>
